module.exports = __webpack_public_path__ + "img/ford-commercial-bg.cdc6a91a.jpeg";